module.exports = __webpack_public_path__ + "img/geofisica_16-9_2880.ab74f470.webp";